import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService, HttpRequestService } from 'src/app/core/services';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  // @Input() isCollapsed = false;
  notificationSelectedClass = false;
  profileSelectedClass = false;
  userInfo = [
    {
      title: 'My profile',
    },
    {
      title: 'Settings',
    },
    {
      title: 'Logout',
    },
  ];
  @Input() isCollapsed: boolean = true;
  @Output() isCollapsedChange: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private authService: AuthService,
    private httpRequestService: HttpRequestService,
    private notificationService: NzNotificationService
  ) {}

  ngOnInit(): void {
    this.isCollapsed = window.innerWidth < 800;
  }
  onChangeCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapsedChange.emit(this.isCollapsed);
  }

  logout(): void {
    this.httpRequestService
      .request('get', 'auth/logout')
      .subscribe((success) => {
        this.notificationService.success(
          'Success',
          'You Successfully Logged out'
        );
      });
    this.authService.logout();
  }
}
